import { render, staticRenderFns } from "./RegistrationFormWithEmail.vue?vue&type=template&id=caf0f010&scoped=true&"
import script from "./RegistrationFormWithEmail.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormWithEmail.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormWithEmail.vue?vue&type=style&index=0&id=caf0f010&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf0f010",
  null
  
)

export default component.exports